import React, { Component } from 'react';
import RegisterHeader from '../partials/RegisterHeader.js';
import Footer from '../partials/Footer.js';

export default class RegisterLayout extends Component {


  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
   document.body.className="inner";
  }

  render() {
    return (
     <div className="row">
     <RegisterHeader/>
      <section className="maincontent">
        <section className="content">
        {this.props.children}
         </section>
      </section>
      <Footer/>
     </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/layouts/RegisterLayout.js